import { hasDemand } from "lib/authorization/has-demand"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { Redirect } from "lib/@components/redirect"
import { appRoute } from "routes/app/home.runtime"

// System Admin is now its own application (see routes/sfg20-admin/system-admin-app.runtime.js).
// The Facilities-iQ nav link below is kept for discoverability but redirects users with access
// into that app; it stays hidden for everyone else.
appRoute.register(
    "system-admin",
    <DemandGuard demands={["admin"]}>
        <Redirect to="/system-admin" />
    </DemandGuard>
)
registerConditionalPageNavigation(
    () => hasDemand("admin"),
    "/app/system-admin",
    "System Admin",
    "ic:twotone-admin-panel-settings",
    {
        group: "More",
        priority: 250,
    }
)
